import CheckoutNextSteps from '~/themes/oknadverenamiru/components/cart/CheckoutNextSteps'
import ContactBox from '~/themes/oknadverenamiru/components/shop/ContactBox'
import ContentBuilder from '@theme/components/utils/ContentBuilder'
import PageArticleDetail from '~/themes/base/components/content/PageArticleDetail'

export default {
  extends: PageArticleDetail,
  components: { CheckoutNextSteps, ContactBox, ContentBuilder },
  props: {
    latestArticles: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    latestArticles: {
      immediate: true,
      handler(newVal) {
        const items = Array.isArray(newVal) ? newVal : []
        const count = this.$themeSettings.components.PageArticleDetail.latestArticles.count
        const perLine =
          this.$themeSettings.components.PageArticleDetail.latestArticles.perLine ||
          (this.$themeSettings.components.ArticleList && this.$themeSettings.components.ArticleList.perLine)

        this.latestArticlesColumnGridClass = this.computeColumnClass(perLine)
        this.latestArticlesFiltered = items.filter(i => i && i._id !== this.article._id && i.title).slice(0, count) // ← SLICE, ne splice
      },
    },
  },
}
